import React from "react";
import { connect } from "react-redux";
import { getBuilderReportId } from "state/ui/report-builder/selectors";
import { getEditedReport } from "state/reports/selectors";
import { editReport } from "state/reports/actions";
import getTimeDimensions from "../../../state/graph-cube/selectors/get-time-dimensions";
import { SidebarOverlay } from "modules/report-builder/layout";
import { map, filter, lowerCase } from "lodash";
import { Box, Text, Stack } from "@towersystems/towersystems-design-system";
import Button from "components/button";
import Dropdown from "react-dropdown";
import { get } from "lodash";

const TimeOverlay = ({
  goBack = () => null,
  selectedTimeDimension,
  selectedDateRange,
  selectedGranularity,
  selectableTimeDimensions = [],
  report,
  ...props
}) => {
  const setSelectedTimeDimension = (value) => {
    props.editReport(report.id ?? null, {
      config: { timeDimension: value.value, test: value.value },
    });
  };

  const setSelectedDateRange = (value) => {
    props.editReport(report.id ?? null, {
      config: { timeDateRange: value.value },
    });
  };

  const setSelectedGranularity = (value) => {
    props.editReport(report.id ?? null, {
      config: { timeGranularity: value.value },
    });
  };

  return (
    <SidebarOverlay goBack={goBack}>
      <Box padding="large">
        <Stack space="large">
          <Box>
            <Text>Time Dimension</Text>
            <Dropdown
              value={selectedTimeDimension}
              options={selectableTimeDimensions.map((t) => ({
                value: t.name,
                label: t.title,
              }))}
              onChange={setSelectedTimeDimension}
            />
          </Box>

          <Box>
            <Text>Date Range</Text>
            <Dropdown
              value={selectedDateRange}
              onChange={setSelectedDateRange}
              options={[
                {
                  label: "Default date range",
                  value: "",
                },
                {
                  label: "Today",
                  value: "Today",
                },
                {
                  label: "Yesterday",
                  value: "Yesterday",
                },
                {
                  label: "This week",
                  value: "This week",
                },
                {
                  label: "This month",
                  value: "This month",
                },
                {
                  label: "This year",
                  value: "This year",
                },
                {
                  label: "Last week",
                  value: "Last week",
                },
                {
                  label: "Last month",
                  value: "Last month",
                },
                {
                  label: "Last year",
                  value: "Last year",
                },
              ]}
            />
          </Box>

          <Box>
            <Text>Granularity</Text>
            <Dropdown
              value={selectedGranularity}
              onChange={setSelectedGranularity}
              options={[
                {
                  label: "Default Granularity",
                  value: "",
                },
                {
                  label: "Day",
                  value: "day",
                },
                {
                  label: "Week",
                  value: "week",
                },
                {
                  label: "Month",
                  value: "month",
                },
                {
                  label: "Year",
                  value: "year",
                },
              ]}
            />
          </Box>
        </Stack>
      </Box>
    </SidebarOverlay>
  );
};

export default connect(
  (state) => {
    const reportId = getBuilderReportId(state);
    const report = getEditedReport(state, reportId);

    const selectableTimeDimensions = getTimeDimensions(state, report.cube);
    const selectedTimeDimension = get(report, "config.timeDimension");
    const selectedDateRange = get(report, "config.timeDateRange");
    const selectedGranularity = get(report, "config.timeGranularity");

    return {
      reportId,
      report,
      selectableTimeDimensions,
      selectedTimeDimension,
      selectedDateRange,
      selectedGranularity,
    };
  },
  {
    editReport,
  }
)(TimeOverlay);
